<div class="dialog-wrapper">
  <app-modal-header-common [title]="data?.template_name" [dialogRef]="dialogRef">
  </app-modal-header-common>
  <div class="dialog-content">
    <div class="plan-form">
      <form [formGroup]="assessmentForm">
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Instance Title</mat-label>
              <input matInput type="text" formControlName="instance_title" placeholder="Instance Title" required />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ displayLabels.portfolio }}</mat-label>
              <input matInput [matAutocomplete]="auto" type="text" formControlName="portfolio" required />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let option of filterOptionPortfolio | async" [value]="option"
                  (onSelectionChange)="onSelectionChangePortfolio($event)">
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ displayLabels.sub_portfolio }}</mat-label>
              <input matInput [matAutocomplete]="auto1" type="text" formControlName="subportfolio" required />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let option of filterOptionSubPortfolio | async" [value]="option"
                  (onSelectionChange)="onSelectionChangeSubportfolio($event)">
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ displayLabels.program }}</mat-label>
              <input matInput [matAutocomplete]="auto2" type="text" formControlName="program" />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let option of filterOptionProgram | async" [value]="option"
                  (onSelectionChange)="onSelectionChangeProgram($event)">
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label> {{ displayLabels?.project | titlecase }} </mat-label>
              <input matInput [matAutocomplete]="auto3" type="text" formControlName="project" />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete #auto3="matAutocomplete" [displayWith]="displayFnProject">
                <mat-option *ngFor="let option of filterOptionProject | async" [value]="option">
                  {{ option.project_name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Vendor</mat-label>
              <input matInput [matAutocomplete]="auto4" type="text" formControlName="vendor" />
              <mat-icon matSuffix class="muted">search</mat-icon>
              <mat-autocomplete #auto4="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let option of filterOptionVendor | async" [value]="option">
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div *ngIf="isMultiRisks">
            <mat-form-field appearance="outline" class="w-100" floatLabel="always">
              <mat-label>Risk</mat-label>
              <mat-chip-list #riskChipList aria-label="Risk selection">
                <mat-chip *ngFor="let risk of selectedRisks; let i = index" [removable]="!isRisklogMode"
                  (removed)="removeRisk(i)">
                  {{ risk?.risk }}
                  <mat-icon matChipRemove *ngIf="!isRisklogMode">cancel</mat-icon>
                </mat-chip>

                <input *ngIf="!isRisklogMode" type="text" placeholder="Search risks..."
                  [formControl]="riskUserInputControl" [matChipInputFor]="riskChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matAutocomplete]="autoRiskMulti"
                  #riskTrigger="matAutocompleteTrigger" (click)="riskTrigger.openPanel()" />
              </mat-chip-list>

              <mat-autocomplete #autoRiskMulti="matAutocomplete" (optionSelected)="addRisk($event.option.value)">
                <mat-option *ngFor="let option of filterOptionRisk | async" [value]="option">
                  {{ option.risk }}
                </mat-option>
                <mat-option *ngIf="(filterOptionRisk | async)?.length === 0" disabled>
                  No mapped risks found
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-hint *ngIf="isRisklogMode" style="font-size: 11px; color: gray">
              Risks are pre-selected and cannot be modified.
            </mat-hint>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="mb-3">
              <app-owner [label]="'Auditor'" moduleName="module.audits" filterOwner="{{ true }}"
                [context]="'assessment'" [required]="true"
                (refereshParentData)="audiencedata($event)"></app-owner>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="mb-3">
              <app-owner [label]="'Respondent'" filterOwner="{{ true }}" [context]="'assessment'" [required]="true"
                 (refereshParentData)="userdata($event)"></app-owner>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Audit Scope</mat-label>
              <textarea matInput formControlName="scope" placeholder="Audit Scope" rows="3"></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Audit Approach</mat-label>
              <textarea matInput formControlName="approach" placeholder="Audit Approach" rows="3"></textarea>
            </mat-form-field>
          </div>
        </div>

        <p class="mb-2">
          Audit Period<span class="required-asterisk"> *</span>
        </p>
        <div class="row">
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="picker1" formControlName="start_date" required />
              <mat-datepicker-toggle matSuffix [for]="picker1">
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="picker2" formControlName="end_date" required />
              <mat-datepicker-toggle matSuffix [for]="picker2">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Audit Start Date</mat-label>
              <input matInput [matDatepicker]="picker3" formControlName="audit_start_date" required />
              <mat-datepicker-toggle matSuffix [for]="picker3">
              </mat-datepicker-toggle>
              <mat-datepicker #picker3></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Audit End Date</mat-label>
              <input matInput [matDatepicker]="picker4" formControlName="audit_end_date" required />
              <mat-datepicker-toggle matSuffix [for]="picker4">
              </mat-datepicker-toggle>
              <mat-datepicker #picker4></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <!-- Applications (multi-select) -->
        <ng-container *ngIf="isProjectSelected">
          <mat-form-field style="width: 100%" appearance="outline" floatLabel="always">
            <mat-label>Applications</mat-label>
            <mat-chip-list #appChipList aria-label="Applications selection">
              <mat-chip *ngFor="let app of selectedApps; let i = index" class="selected-app" [selectable]="true"
                [removable]="true" (removed)="removeApp(i)">
                {{ app?.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>

              <input type="text" placeholder="Search applications..." [formControl]="appUserInputControl"
                [matChipInputFor]="appChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true" [matAutocomplete]="appAuto" #appOperationTrigger="matAutocompleteTrigger"
                name="application_name" (click)="appOperationTrigger.openPanel()" />
            </mat-chip-list>

            <mat-autocomplete #appAuto="matAutocomplete" (optionSelected)="addApp($event.option.value)">
              <mat-option *ngFor="let option of appFilteredOptions | async" [value]="option">
                <span class="autofill-option">{{ option.name }}</span>
              </mat-option>

              <!-- No records found -->
              <mat-option *ngIf="(appFilteredOptions | async)?.length === 0" disabled>
                {{ commonText.no_records_found }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </ng-container>
      </form>
    </div>
  </div>
  <div class="modal-footer" style="display: flex; justify-content: space-between">
    <button mat-button mat-dialog-close (click)="goBackModal()" color="primary" class="mx-1">
      Go Back
    </button>
    <div style="display: flex; justify-content: end">
      <button mat-button mat-dialog-close color="primary" class="mx-1">
        Close
      </button>

      <button mat-raised-button color="primary" class="templ-btn ms-1" (click)="createAssessment()" [disabled]="
          assessmentForm.invalid ||
          !this.selectedAudience.length ||
          !this.selectedOwners.length
        ">
        Create
      </button>
    </div>
  </div>
</div>